import { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// Inside a split-view report pane, a handler can keep navigation inside the pane (returns true if handled)
export const PaneNavContext = createContext(null);

export const usePaneNavigate = () => {
  const navigate = useNavigate();
  const paneHandler = useContext(PaneNavContext);
  return (to, opts) => {
    if (paneHandler && typeof to === 'string' && paneHandler(to)) return;
    navigate(to, opts);
  };
};
